import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const HeaderBar = styled.header`
  background: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.white};
  padding: 20px 0;
  position: relative;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
  min-height: 110px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
`;

const Brand = styled(Link)`
  font-size: 24px;
  font-weight: 700;
  text-decoration: none;
  color: ${props => props.theme.colors.white};
  display: flex;
  align-items: center;
  
  img {
    width: 110px;
    height: 110px;
    display: block;
    object-fit: contain;
    transition: transform 0.3s ease;
    box-sizing: border-box;
    
    &:hover {
      transform: scale(1.05);
    }

    &:focus-visible{
      outline: none;
    }
  }
  
  @media (max-width: 768px) {
    img {
      width: 80px;
      height: 80px;
    }
  }
`;

const ContactInfo = styled.div`
  font-size: 14px;
  text-align: right;
  line-height: 1.4;
  
  strong { 
    font-weight: 700; 
  }
  
  div {
    margin-bottom: 2px;
  }
  
  @media (max-width: 768px) {
    text-align: center;
    order: 3;
  }
`;

const Header = () => {
  return (
    <HeaderBar>
      <Container>
        <HeaderContent>
          <Brand to="/" aria-label="Santa Casa Copacabana">
            <img src="/logoscc.png" alt="Santa Casa Copacabana" />
          </Brand>
          <ContactInfo>
            <div><strong>Santa Casa Copacabana</strong></div>
            <div>Com Você Sempre</div>
          </ContactInfo>
        </HeaderContent>
      </Container>
    </HeaderBar>
  );
};

export default Header;
